import { render, staticRenderFns } from "./TractNotes.vue?vue&type=template&id=5a33b77a&"
import script from "./TractNotes.vue?vue&type=script&lang=js&"
export * from "./TractNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports